import { z } from "zod";

// Define the Zod schema for activity validation
export const activitySchema = z.object({
  title: z.string().min(1, "Le nom de l'activité est requis"),
  description: z.string().optional(),
  color: z.string().min(1, "La couleur est requise"),
  icon: z.string().min(1, "L'icône est requise"),
  startDay: z.string().min(1, "La date de début est requise"),
  startTime: z.string().min(1, "L'heure de début est requise"),
  endDay: z.string().optional(),
  endTime: z.string().optional(),
  participants: z
    .array(
      z.object({
        organizationId: z.string(),
        userOrganizationId: z.string(),
        label: z.string(),
      })
    )
    .optional(),
  groupParticipants: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
      })
    )
    .optional(),
  locationAddress: z.string().optional(),
  locationCity: z.string().optional(),
  locationCountryCode: z.string().optional(),
  locationLabel: z.string().optional(),
  locationZipCode: z.string().optional(),
  locationLatitude: z.number().optional(),
  locationLongitude: z.number().optional(),
  locationPhotoUrls: z.array(z.string()).optional(),
  documents: z
    .array(
      z.object({
        title: z.string().min(1, "Le titre du document est requis"),
        description: z.string().optional(),
        file: z.any().optional(), // We'll handle file validation separately
      })
    )
    .optional(),
  contacts: z
    .array(
      z.object({
        name: z.string(),
        email: z.string().optional(),
        phoneNumber: z.string().optional(),
        description: z.string().optional(),
        id: z.string().optional(), // In case of update we will have the id already
      })
    )
    .optional(),
});

// Infer the TypeScript type from the schema
export type ActivityFormValues = z.infer<typeof activitySchema>;

export const defaultValues: ActivityFormValues = {
  title: "",
  description: "",
  color: "#d3c37b",
  icon: "default",
  startDay: "",
  startTime: "",
  endDay: "",
  endTime: "",
  participants: [],
  groupParticipants: [],
  locationAddress: "",
  locationCity: "",
  locationCountryCode: "FR",
  locationLabel: "",
  locationZipCode: "",
};
